module.exports = __webpack_public_path__ + "img/231.8d952893.jpg";